<!--
 * @Author: 曹捷
 * @Date: 2020-06-02 09:11:01
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-04-28 09:34:41
 * @Description: 
 SAAS 服务菜单 
 菜单分三级菜单
 左侧菜单最多展示两级
 第三级通过content主题  tabs 展示第三级
--> 
<template>
  <div class="left-menu" id="left-menu" :class="classObj">
    <obitScrollbarVue>
      <a-menu id="layout-menu" mode="inline" @click="toPath" v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys">
        <sidebar-item :base-path="route.path" :item="route" :key="route[config.menu.key]" v-for="route in routes" />
      </a-menu>
    </obitScrollbarVue>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
import { computed, provide, reactive, toRaw, toRefs, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import obitScrollbarVue from 'obit-wui/components/obit-scrollbar'
import { util } from 'obit-wui'
import qkStore from 'obit-wui/qiankun/qkStore'
import MenuHook from './../hook/menu'
import { pushState } from './../hook/history'
export default {
  components: { SidebarItem, obitScrollbarVue },
  setup () {
    let store = useStore()
    let router = useRouter()
    let route = useRoute()
    let config = store.state.settings
    let menuList = store.state.permission.menuList
    let menuHook = MenuHook()
    let methods = {
      sysnMenuSelectKey () {
        let item = menuList.find(ele => {
          return ele[config.menu.url] === route.path
        })
        if (item && !item.pId) {
          let key = item.path.replace('/', '')
          let appRedirect = qkStore.getGlobalState('appRedirect')
          console.log('🚀 ~ file: sidebar.vue ~ line 51 ~ sysnMenuSelectKey ~ appRedirect', appRedirect)
          // 如果是子应用首页 获取子应用菜单
          if (appRedirect[key]) {
            item = menuList.find(ele => {
              return ele[config.menu.url] === appRedirect[key]
            })
          }
        }
        let pList = menuHook.getRouteList(store, route)
        if (pList.length >= 2) {
          return [pList[0]]
        }
        return [item ? item[config.menu.key] : '']
      }
    }
    let _data = reactive({
      selectedKeys: methods.sysnMenuSelectKey(),
      openKeys: function () {
        return menuHook.getRouteList(store, route)
      }(),
      oldOpenKey: []
    })
    let menuCache = {}
    let _computed = {
      menuList: computed(() => menuList),
      // 菜单转化  只要两层  若有第三层 在body内体现
      routes: computed(() => {
        let cache = {}
        if (store.state.permission.sysMenu) {
          let list = util.util.cloneObj(store.state.permission.sysMenu)
          list.forEach(element => {
            let child = element[config.menu.children]
            if (child && child.length > 0) {
              child.forEach(ele => {
                let secondChild = ele[config.menu.children]
                if (secondChild && secondChild.length > 0) {
                  cache[ele.path] = secondChild
                  ele[config.menu.children] = []
                }
              })
            }
          })
          menuCache = cache
          return list
        }
        return []
      }),
      config: computed(() => config),
      classObj: computed(() => {
        let obj = {}
        obj[config.layout + '-menu'] = true
        return obj
      })
    }
    let _methods = {
      toPath ({ item, key }) {
        let info = toRaw(menuList.find(ele => ele[config.menu.key] == key))
        info.mateName = info[config.menu.name]
        store.dispatch('tagsView/addVisitedView', info)
        // console.log('🚀乾坤子应用', route.path, info[config.menu.url], config)
        if (route.path !== info[config.menu.url]) {
          // 主框架 微应用跳转
          // 二级菜单  下面还有三级菜单，默认跳转到二级菜单的第一个三级菜单
          for (const key in menuCache) {
            if (info.path.indexOf(key) !== -1) {
              let child = menuCache[key][0]
              pushState(child[config.menu.url])
              return
            }
          }
          pushState(info[config.menu.url])
        }
      }
    }
    watch(() => store.state.settings.menu.opened, (value, evalue) => {
      if (value) {
        _data.oldOpenKey = _data.openKeys
        _data.openKeys = []
      } else {
        _data.openKeys = _data.oldOpenKey
      }
    })
    watch(() => route.path, (value) => {
      _data.openKeys = menuHook.getRouteList(store, route)
      _data.selectedKeys = methods.sysnMenuSelectKey()
    })
    return {
      ...toRefs(_data),
      ..._computed, ..._methods
    }
  },
}
</script>

